
import * as XLSX from 'xlsx';
import * as constants from '../filestatus/dlaconstants';

export function  helloWorld() {
    return "Hi";
}

export function validateBomLineItemSheet(workBook){
    let worksheet = workBook.Sheets[constants.LINE_ITEM_SHEET_NAME];
    if(worksheet){
        var range = XLSX.utils.decode_range(worksheet['!ref']);
        var R = range.s.r;
        var endColumn = range.e.c;
        var index = new Map();
        for(var C = range.s.c; C <= endColumn; ++C) {
            var cell = worksheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
            var cellValue = XLSX.utils.format_cell(cell);
            if(constants.MANDATORY_LINEITEM_KEYS.includes(cellValue)){
                console.log(cellValue);
                index[cellValue]=C;
            }
        }
        console.log(index);

        var commentColumn = index[constants.COMMENTS];
        var suppliedMaterialColumn = index[constants.PCX_SUPP_NUMBER];
        var colorColumn = index[constants.COLOR];

        var commentValue = XLSX.utils.format_cell(worksheet[XLSX.utils.encode_cell({c:commentColumn, r:2})])
        var suppliedMaterialColumnValue = XLSX.utils.format_cell(worksheet[XLSX.utils.encode_cell({c:suppliedMaterialColumn, r:2})])
        var colorColumnValue = XLSX.utils.format_cell(worksheet[XLSX.utils.encode_cell({c:colorColumn, r:2})])
           
        console.log(commentValue)
        console.log(suppliedMaterialColumnValue)
        console.log(colorColumnValue)

        let errorMessage = "";
        
        if((!commentValue || commentValue==="") && (!suppliedMaterialColumnValue || suppliedMaterialColumnValue==="")
             && (!colorColumnValue || colorColumnValue==="")){
                errorMessage=`Column(s) ${constants.COMMENTS}, ${constants.PCX_SUPP_NUMBER} & ${constants.COLOR} of 
                row number 3 contain blank values in the ${constants.LINE_ITEM_SHEET_NAME} worksheet`;
        }
        return errorMessage;
              
    }
}

export function getWorkBook(data){
    var o = "", l = 0, w = 10240;
	for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
	o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
          
    return XLSX.read(btoa(o), {type: 'base64'})
}

export function validateBOMHeader(workBook){
    let worksheet = workBook.Sheets[constants.LOGIC_BOM_HEADER_SHEET_NAME];
    
    let missingMandatoryAttributes = [];
    let versionMismatch ;
    var range = XLSX.utils.decode_range("A1:F2");

    var C, R = range.s.r; /* start in the first row */
    var columnValue = new Map();
    for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        var cell = worksheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
        var cellValue = worksheet[XLSX.utils.encode_cell({c:C, r:range.e.r})] /* find the cell in the first row */
        columnValue[XLSX.utils.format_cell(cell)]=XLSX.utils.format_cell(cellValue);
        //console.log(XLSX.utils.format_cell(cell) +" --> "+XLSX.utils.format_cell(cellValue));
    }
    var arr = constants.MANDATORY_BOM_HEADER_KEYS;
    var temp;
    for (var i = 0; i < arr.length; i++) {              
        temp = columnValue[arr[i]];
        if(temp){
            //console.log(arr[i]+"===>"+temp);
            if(arr[i]===constants.TEMPLATEVERSION && temp!==constants.TEMPLATEALLOWEDVERSION){
                versionMismatch=`Expected: ${constants.TEMPLATEALLOWEDVERSION}, found: ${temp}`;
            }
                
        }else{
            missingMandatoryAttributes.push(arr[i]);
        }
    }
    let errorMessage = "";
    if (missingMandatoryAttributes.length>0) {
        errorMessage=`Column(s) ${missingMandatoryAttributes.toString()}  contain blank values`;
    }
    
    if(versionMismatch){
        if(errorMessage){
         errorMessage += ` and ${constants.TEMPLATEVERSION} is not valid(${versionMismatch})`;
        }else{
         errorMessage = `${constants.TEMPLATEVERSION} is not valid. ${versionMismatch}`;
        }
    }

    return errorMessage;
}

export function validateSheetNames(workBook){
        
    let sheet_name_list = workBook.SheetNames;

    const logicBomHeaderSheet = sheet_name_list.find((item) => item === constants.LOGIC_BOM_HEADER_SHEET_NAME);
    const logicBomLineItemDetailSheet = sheet_name_list.find((item) => item === constants.LINE_ITEM_SHEET_NAME);

    let errors = [];

    if (!logicBomHeaderSheet) {              
        errors.push(constants.LOGIC_BOM_HEADER_SHEET_NAME);
    }
    if (!logicBomLineItemDetailSheet) {              
        errors.push(constants.LINE_ITEM_SHEET_NAME);
    }

    return errors;
}